/**
 * Jambuveda Wellness Finder
 * 3-step flow -> POST {concern,intensity,goal} to <endpoint>/finder
 * -> render routine text + a product card for the returned handle.
 * If no endpoint is set, runs in PREVIEW mode with a canned response so the
 * UI can be seen before the backend is deployed.
 */
(function () {
  const root = document.querySelector(".jv-finder");
  if (!root) return;

  const endpoint = (root.dataset.endpoint || "").trim().replace(/\/$/, "");
  const shopUrl = (root.dataset.shopUrl || "").replace(/\/$/, "");
  const steps = Array.from(root.querySelectorAll("[data-step]"));
  const progress = root.querySelector("[data-jv-progress]");
  const resultEl = root.querySelector("[data-jv-result]");
  const answerEl = root.querySelector("[data-jv-answer]");
  const pickEl = root.querySelector("[data-jv-pick]");
  const loadingEl = root.querySelector("[data-jv-loading]");
  const restartBtn = root.querySelector("[data-jv-restart]");

  const answers = {};
  let stepIndex = 0;

  function showStep(i) {
    steps.forEach((s, idx) => s.classList.toggle("is-active", idx === i));
    if (progress) progress.style.width = Math.round(((i + 1) / steps.length) * 100) + "%";
  }

  root.querySelectorAll(".jv-finder__opt").forEach((btn) => {
    btn.addEventListener("click", () => {
      answers[btn.dataset.key] = btn.dataset.val;
      if (stepIndex < steps.length - 1) {
        stepIndex += 1;
        showStep(stepIndex);
      } else {
        submit();
      }
    });
  });

  function setBusy(b) {
    loadingEl.hidden = !b;
    steps.forEach((s) => (s.style.display = b ? "none" : ""));
    if (b) { resultEl.hidden = true; }
  }

  async function submit() {
    setBusy(true);
    try {
      let data;
      if (!endpoint) {
        // preview fallback
        await new Promise((r) => setTimeout(r, 700));
        data = {
          text:
            "Thanks for sharing. Based on what you've told me, start simple: warm water with a pinch of ajwain after meals, a 10-minute walk in the evening, and an early, light dinner. Give it a few weeks — Ayurveda works gradually. Gas Go can support easier digestion alongside this routine.",
          product_handle: "gas-go",
        };
      } else {
        const res = await fetch(endpoint + "/finder", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(answers),
        });
        if (!res.ok) throw new Error("finder failed " + res.status);
        data = await res.json();
      }
      renderResult(data);
    } catch (err) {
      console.error("Wellness Finder error", err);
      answerEl.textContent =
        "Jeevak is resting for a moment. Please try again shortly — or explore our formulas by concern.";
      pickEl.hidden = true;
      loadingEl.hidden = true;
      resultEl.hidden = false;
    } finally {
      loadingEl.hidden = true;
    }
  }

  function renderResult(data) {
    answerEl.textContent = data.text || "";
    if (data.product_handle) {
      // link to the product page; the card is intentionally simple (name+link)
      const handle = data.product_handle;
      const nice = handle.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
      pickEl.innerHTML =
        '<a class="jv-finder__pick-card" href="' + shopUrl + "/products/" + handle + '">' +
        '<span class="jv-finder__pick-label">Jeevak suggests</span>' +
        '<span class="jv-finder__pick-name">' + nice + "</span>" +
        '<span class="jv-finder__pick-cta">View product →</span>' +
        "</a>";
      pickEl.hidden = false;
    } else {
      pickEl.hidden = true;
    }
    resultEl.hidden = false;
  }

  restartBtn?.addEventListener("click", () => {
    for (const k in answers) delete answers[k];
    stepIndex = 0;
    resultEl.hidden = true;
    steps.forEach((s) => (s.style.display = ""));
    showStep(0);
  });

  showStep(0);
})();
